import { 
    GAME_FACT_SOCCER_STOP, 
    GAME_FACT_SOCCER_BUT,
    GAME_FACT_SOCCER_SHOT,
    GAME_FACT_SOCCER_SHOOTOUTPENALTY,
    GAME_FACT_SOCCER_FAULT,
    GAME_FACT_SOCCER_YELLOWCARD,
    GAME_FACT_SOCCER_SECONDYELLOWCARD,
    GAME_FACT_SOCCER_REDCARD,
    GAME_FACT_SOCCER_REPLACEMENT,
    GAME_FACT_SOCCER_PENALTY,
    GAME_FACT_SOCCER_STAR,
    GAME_FACT_SOCCER_COMMENT
} from '../../constants.js'
import { ButDto } from '../../gamefacts/soccer/ButDto.js'
import { CommentDto } from '../../gamefacts/soccer/CommentDto.js.js'
import { FaultDto } from '../../gamefacts/soccer/FaultDto.js'
import { PenaltyDto } from '../../gamefacts/soccer/PenaltyDto.js'
import { RedCardDto } from '../../gamefacts/soccer/RedCardDto.js'
import { ReplacementDto } from '../../gamefacts/soccer/ReplacementDto.js'
import { ShootoutPenaltyDto } from '../../gamefacts/soccer/ShootoutPenaltyDto.js'
import { ShotDto } from '../../gamefacts/soccer/ShotDto.js'
import { StarDto } from '../../gamefacts/soccer/StarDto.js'
import { StopDto } from '../../gamefacts/soccer/StopDto.js'
import { YellowCardDto } from '../../gamefacts/soccer/YellowCardDto.js'
  
export const soccerResolvers = {
    [GAME_FACT_SOCCER_STOP]: (event) => new StopDto(event),
    [GAME_FACT_SOCCER_BUT]: (event) => new ButDto(event),
    [GAME_FACT_SOCCER_SHOT]: (event) => new ShotDto(event),
    [GAME_FACT_SOCCER_SHOOTOUTPENALTY]: (event) => new ShootoutPenaltyDto(event),
    [GAME_FACT_SOCCER_FAULT]: (event) => new FaultDto(event),
    [GAME_FACT_SOCCER_YELLOWCARD]: (event) => new YellowCardDto(event),
    [GAME_FACT_SOCCER_SECONDYELLOWCARD]: (event) => new YellowCardDto(event),
    [GAME_FACT_SOCCER_REDCARD]: (event) => new RedCardDto(event),
    [GAME_FACT_SOCCER_REPLACEMENT]: (event) => new ReplacementDto(event),
    [GAME_FACT_SOCCER_PENALTY]: (event) => new PenaltyDto(event),
    [GAME_FACT_SOCCER_STAR]: (event) => new StarDto(event),
    [GAME_FACT_SOCCER_COMMENT]: (event) => new CommentDto(event),
}